export const Debounce = () => {
  let timeout: ReturnType<typeof setTimeout>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (fn: any, wait = 200) => {
    clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  };
};
